// ANGULAR
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// MODELS
import { Secret } from '@models/secretos.model';
import { Configuration } from '@models/configuraciones.model';
// RXJS
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionesService {
  readonly httpOptions: { headers: HttpHeaders, params: HttpParams } = { headers: new HttpHeaders({ 'content-type': 'application/json', 'accept': 'application/json' }), params: new HttpParams() };

  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { }

  getConfiguraciones(names?: string[]): Observable<Configuration[]> {
    let params: HttpParams = new HttpParams();
    if (!!names) {
      let formattedNames: string = '';
      for (let i = 0; i < names.length; i++) {
        if (i === 0) {
          formattedNames = `${names[i]}`;
        } else {
          formattedNames = `${formattedNames}|${names[i]}`;
        }
      }
      params = params.set('nombres', formattedNames);
    }

    return this.http.get<Configuration[]>(`${this.globalService.apiUrl.url}/Configuraciones`, { ...this.httpOptions, params });
  }

  postCreateConfiguracion(configuration: Configuration): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/Configuraciones`, configuration, this.httpOptions);
  }

  getConfiguracion(name: string): Observable<Secret> {
    return this.http.get<Secret>(`${this.globalService.apiUrl.url}/Configuraciones/${name}`, this.httpOptions);
  }

  putEditConfiguracion(name: string, configuration: Configuration): Observable<void> {
    return this.http.put<void>(`${this.globalService.apiUrl.url}/Configuraciones/${name}`, configuration, this.httpOptions);
  }

  deleteConfiguracion(name: string): Observable<void> {
    return this.http.delete<void>(`${this.globalService.apiUrl.url}/Configuraciones/${name}`, this.httpOptions);
  }
}